export const CUSTOMER_LIST = "customer_list";
export const GROUP_LIST = "group_list";

export const GROUP_MEMBER_LIST = "group_member_list";
export const CONVERSATION_ID = "conversation_id";
export const MESSAGE_LIST = "message_list";
export const SYSTEM_MESSAGE_COUNT = "system_message_count";
